/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @link https://github.com/invoiceninja/invoiceninja source repository
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export function File(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 56 56"
      version="1.1"
      viewBox="0 0 56 56"
      xmlSpace="preserve"
    >
      <path
        fill="#E9E9E0"
        d="M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z"
      ></path>
      <path fill="#D9D7CA" d="M37.5 0.151L37.5 12 49.349 12z"></path>
      <path
        fill="#C8BDB8"
        d="M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z"
      ></path>
      <circle cx="18.5" cy="47" r="3" fill="#FFF"></circle>
      <circle cx="28.5" cy="47" r="3" fill="#FFF"></circle>
      <circle cx="38.5" cy="47" r="3" fill="#FFF"></circle>
    </svg>
  );
}
